// extracted by mini-css-extract-plugin
export default {"featuresList":"featuresList_NPJcp_9m"};